const borderRadius = {
    low: '0.4rem',
    medium: '0.8rem',
    mediumHigh: '1.2rem',
    high: '1.6rem',
    highM: '2rem',
    highL: '7.2rem',
    highest: '50%',
    x1: '0.4rem',
    x2: '0.8rem',
    x3: '1.2rem',
    x4: '1.6rem',
    x5: '2rem',
    x6: '2.4rem',
    x7: '2.8rem',
    x8: '3.2rem',
    x9: '3.6rem',
    x10: '4rem',
    x12: '4.8rem',
    x14: '5.6rem',
    x16: '6.4rem',
    x24: '9.6rem',
    x32: '12.8rem',
};
export default borderRadius;
//# sourceMappingURL=borderRadius.js.map